export const isShadowDOMEnabled = () => Boolean(document.body.attachShadow)
